import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  RecaptchaVerifier,
  signInWithPhoneNumber,
  PhoneAuthProvider,
  signInWithCredential,
} from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getMessaging } from "firebase/messaging";
import { getFirestore } from "firebase/firestore";
import { getToken } from "firebase/messaging";
import { isSupported } from "firebase/messaging";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FB_API_KEY,
  authDomain: process.env.REACT_APP_FB_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FB_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FB_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FB_MESSAGIN_SENDER_ID,
  appId: process.env.REACT_APP_FB_APP_ID,
  measurementId: process.env.REACT_APP_FB_MEASUREMENT_ID,
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();
export const analytics = getAnalytics(app);

let recaptchaVerifier = null;

export const messaging = (async () => {
  try {
    const isSupportedBrowser = await isSupported();
    if (isSupportedBrowser) {
      return getMessaging(app);
    }
    console.log("Firebase is not supported in this browser");
    return null;
  } catch (err) {
    console.log(err);
    return null;
  }
})();

export const generateToken = async () => {
  const permission = await Notification.requestPermission();
  if (permission === "granted") {
    console.log("Notification permission granted.");
    console.log(process.env.REACT_APP_FB_VAPID_KEY);

    const token = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FB_VAPID_KEY,
    });
    console.log("FCM Token:", token);
  } else {
    console.log("Notification permission denied.");
  }
};

const initializeRecaptcha = (containerId, callback) => {
  // Clear any existing verifier
  if (recaptchaVerifier) {
    recaptchaVerifier.clear();
  }

  // Initialize new verifier
  recaptchaVerifier = new RecaptchaVerifier(auth, containerId, {
    size: "normal",
    callback: (response) => {
      console.log("reCAPTCHA solved", response);
      if (callback) callback(response);
    },
    "expired-callback": () => {
      console.log("reCAPTCHA expired");
      // Optionally handle expiration
    },
  });

  // Render the widget
  recaptchaVerifier.render();

  return recaptchaVerifier;
};

const getRecaptchaVerifier = () => {
  return recaptchaVerifier;
};

const resetRecaptcha = () => {
  if (recaptchaVerifier) {
    try {
      recaptchaVerifier.clear();
    } catch (error) {
      console.log("Error clearing recaptcha:", error);
    }
    recaptchaVerifier = null;
  }
};

export {
  RecaptchaVerifier,
  signInWithPhoneNumber,
  PhoneAuthProvider,
  getRecaptchaVerifier,
  signInWithCredential,
  initializeRecaptcha,
  resetRecaptcha,
};
